<template>
  <button
    class="btn btn-default btn-sm"
    @click="$router.back()"
  >
    {{ $t('button.back') }}
  </button>
</template>

<script>
export default {
  name: 'AsoraBackButton'
}
</script>

<style scoped>

</style>
